import $ from 'jquery'
import NProgress from 'nprogress'
import store from '@/store'

export default {
    name: 'registre-ge',
    components: {},
    props: [],
    data () {
        return {
            analyse:"GE",
            listeRegistre: [],
            loading:false,
            sta:null,
            l_resultat: [
                {
                    "id": 1,
                    "libelle": "Positif",
                    "state": true,
                },
                {
                    "id": 2,
                    "libelle": "Négatif",
                    "state": false
                }
            ], 
            l_presence_de: [
                {
                    "id": 1,
                    "libelle": "Trophozoïte"
                },
                {
                    "id": 2,
                    "libelle": "Schizonte"
                },
                {
                    "id": 3,
                    "libelle": "Gamétocyte"
                }
            ],
            l_plasmodium: [
                {
                    "id": 1,
                    "libelle": "Falciparum"
                },
                {
                    "id": 2,
                    "libelle": "Malariae"
                },
                {
                    "id": 3,
                    "libelle": "Ovale"
                },
                {
                    "id": 4,
                    "libelle": "Vivax"
                }
            ]
        }
    },
    async beforeRouteEnter(to, from,next)
    {
        NProgress.start()
        await store.dispatch("getPlasmodiums")
        await store.dispatch("getStadesPlasmodiums")
        await store.dispatch("getRegistre","GE").then(
            ()=>{
                next(vm =>{
                    vm.$root.listeRegistre = vm.$root.registre
                }) 
                NProgress.done()
            }
        )
    },
    computed: {
        plasmodiums(){
            return this.$store.getters["plasmodiums"];
        },
        stadesPlasmodiums(){
            return this.$store.getters["stadesPlasmodiums"];
        },
        registre(){
            return this.$store.getters["registre"]
        }
    },
    created(){
        this.listeRegistre = this.registre
    },
    mounted () {
        setTimeout(() => {
            $('.shw').fadeIn()
        }, 500);

        /* this.$store.dispatch("getPlasmodiums")
        this.$store.dispatch("getStadesPlasmodiums")
        this.$store.dispatch("getRegistre",this.analyse).then(
            ()=>{
                this.listeRegistre = this.registre
            }
        ) */
    },
    methods: {
        saveResults: function(){
            this.loading = true
            this.$store.dispatch("saveDemandesResult",{data:this.listeRegistre,analyse:this.analyse}).then(
                () =>{
                  this.loading = false 
                  this.successMessage()
                }
            )
         },
         successMessage: function(){
             this.$toasted.show('Les résultats ont été enregistrés',{
                 duration: 2000,
                 action:[
                     {
                     text:'X',
                     onClick:(e,toastObject)=>{
                         toastObject.goAway(0);
                     }
                     }
                 ],
                 theme:'toasted-primary',
                 type:'success',
                 position:'top-center'
             })
         },

    }
}


